import { getQueueConfig } from '../store/localstorage';
import { BOOK_APPOINTMENT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface RequestResponse {
    success: boolean;
    appointment: Appointment;
    nextUrl: string;
    payment_id?: null;
    error?: {
        type?: string;
    };
}
export interface Appointment {
    date: string;
    doctor_oid: string;
    aid: string;
    patient_uuid: string;
    patient_oid: string;
    clinic_id: string;
    channel: string;
    onsched_id: string;
    status: string;
    start_time: string;
    end_time: string;
    created_at: string;
    amount: number;
    service: string;
}

export interface RequestBody {
    payload: Payload;
}
export interface Payload {
    isoDateTime: string;
    profile: Profile;
    channel: string;
}
export interface Profile {
    oid: string;
}

export default ({
    dateTime,
    ptOid,
    channel,
    docId,
    cId,
}: {
    dateTime: string;
    ptOid: string;
    channel: 'Walkin';
    docId: string;
    cId: string;
}): Promise<RequestResponse> => {
    if (window.bookSlot) {
        return window
            .bookSlot({
                channel,
                mode: 'in-clinic',
                clinicId: cId,
                doctorId: docId,
                patient: {
                    oid: ptOid,
                    allowMultiBooking: getQueueConfig()?.apt_config?.allow_pt_multi_apt,
                },
                startTime: new Date().toISOString(),
                endTime: new Date().toISOString(),
                action: 'CK',
            })
            .then((res) => {
                return {
                    success: true,
                    appointment: res.data as Appointment,
                    nextUrl: '',
                };
            });
    }
    const request: RequestBody = {
        payload: {
            isoDateTime: dateTime,
            profile: {
                oid: ptOid,
            },
            channel,
        },
    };
    return fetchWithRefresh(BOOK_APPOINTMENT(docId, cId), {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-type': 'application/json',
        },
    }).then((res) => {
        return res.json();
    });
};
